const init_state = {
  doctorTable: false,
  orderTypes: false,
  orderProcess: false,
};
const updateReducer = (state = init_state, action) => {
  if (action.type === "update_doctor_table") {
    return {
      ...state,
      doctorTable: !state.doctorTable,
    };
  }
  if (action.type === "update_order_types") {
    return {
      ...state,
      orderTypes: !state.orderTypes,
    };
  }
  if (action.type === "update_order_process") {
    return {
      ...state,
      orderProcess: !state.orderProcess,
    };
  }

  return state;
};

export default updateReducer;
